var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.97 38.97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.49,
    cy: 19.49,
    fill: "#906351",
    r: 19.49
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.49 9.43c3.28 0 3.66.01 4.96.07 1.2.05 1.85.25 2.28.42.57.22.98.49 1.41.92s.7.84.92 1.41c.17.43.37 1.08.42 2.28.06 1.29.07 1.68.07 4.96s-.01 3.66-.07 4.96c-.05 1.2-.25 1.85-.42 2.28-.22.57-.49.98-.92 1.41s-.84.7-1.41.92c-.43.17-1.08.37-2.28.42-1.29.06-1.68.07-4.96.07s-3.66-.01-4.96-.07c-1.2-.05-1.85-.25-2.28-.42-.57-.22-.98-.49-1.41-.92s-.7-.84-.92-1.41c-.17-.43-.37-1.08-.42-2.28-.06-1.29-.07-1.68-.07-4.96s.01-3.66.07-4.96c.05-1.2.25-1.85.42-2.28.22-.57.49-.98.92-1.41s.84-.7 1.41-.92c.43-.17 1.08-.37 2.28-.42 1.29-.06 1.68-.07 4.96-.07m0-2.21c-3.33 0-3.75.01-5.06.07s-2.2.27-2.98.57c-.81.31-1.49.73-2.17 1.42-.68.68-1.1 1.37-1.42 2.17-.3.78-.51 1.67-.57 2.98s-.07 1.73-.07 5.06.01 3.75.07 5.06.27 2.2.57 2.98c.31.81.73 1.49 1.42 2.17.68.68 1.37 1.1 2.17 1.42.78.3 1.67.51 2.98.57s1.73.07 5.06.07 3.75-.01 5.06-.07 2.2-.27 2.98-.57c.81-.31 1.49-.73 2.17-1.42.68-.68 1.1-1.37 1.42-2.17.3-.78.51-1.67.57-2.98s.07-1.73.07-5.06-.01-3.75-.07-5.06-.27-2.2-.57-2.98c-.31-.81-.73-1.49-1.42-2.17-.68-.68-1.37-1.1-2.17-1.42-.78-.3-1.67-.51-2.98-.57s-1.73-.07-5.06-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.49 13.19c-3.48 0-6.3 2.82-6.3 6.3s2.82 6.3 6.3 6.3 6.3-2.82 6.3-6.3-2.82-6.3-6.3-6.3zm0 10.39c-2.26 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09 4.09 1.83 4.09 4.09-1.83 4.09-4.09 4.09z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.03,
    cy: 12.94,
    r: 1.47
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bff0401a696021236543b8063acf97ba.svg";
export { ForwardRef as ReactComponent };